























































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CustomButton from '@/components/atoms/neon/CustomButton.vue';
import CustomTextField, {
  TextRuleType,
} from '@/components/atoms/neon/CustomTextField.vue';
import EditableList from '@/components/molecules/EditableList.vue';
import FormDialog from '@/components/molecules/FormDialog.vue';
import { BusEvent, BusEventTargets } from '@/containers/globals/BusEvent';
import { i18n } from '@/plugins/i18n/i18n';
import {
  ID,
  LinkMenu,
  EditActionEvent,
  EditLinkMenuItem,
  EditActionBehavior,
  ChangeEvent,
  SaveEvent,
  CloseEvent,
} from '@/types/type';
import { isValidUrl } from '@/utils/CommonUtils';

export interface EditLinkBehavior {
  add: () => void;
  edit: () => void;
}

export interface IEditItem extends EditLinkMenuItem {
  editType: keyof EditLinkBehavior;
}

@Component({
  components: {
    FormDialog,
    EditableList,
    CustomButton,
    CustomTextField,
  },
})
export default class PortalLinkEditDialog extends Vue {
  private btnCancel = i18n.tc('common.cancel');
  private btnSave = i18n.tc('common.save');
  private titleUpdateLink = i18n.tc('portal.linksUpdation');
  private btnLinkAdd = i18n.tc('portal.linkAdd');
  private labelTitle = i18n.tc('portal.linkEditTitle');
  private labelUrl = i18n.tc('portal.linkEditUrl');
  private labelDescription = i18n.tc('portal.linkEditDescription');
  private ruleInputRequired = i18n.tc('portal.ruleInputRequired');
  private ruleInputUrl = i18n.tc('portal.ruleInputUrl');

  private rules: { [key: string]: TextRuleType } = {
    required: value => !!value || this.ruleInputRequired,
    url: value => isValidUrl(value) || this.ruleInputUrl,
  };

  private editMenuEvent = BusEventTargets.FORM_DIALOG_LINK;
  private editItemEvent = BusEventTargets.FORM_DIALOG_LINK_ITEM;

  private editType: keyof EditLinkBehavior = 'add';
  private modelId: ID = '';
  private modelTitle: string = '';
  private modelUrl: string = '';
  private modelIndex: number = -1;
  private titleText: string = '';
  private saveButtonText: string = '';

  @Prop()
  private menus!: LinkMenu[];

  @Emit('edit-action')
  private editAction(event: EditActionEvent): EditActionEvent {
    const behavior: EditActionBehavior = {
      edit: () => this.editLink(event.menu as LinkMenu, event.index),
      top: () => {},
      up: () => {},
      down: () => {},
      bottom: () => {},
      remove: () => {},
    };
    behavior[event.action]();
    return { ...event, change: true };
  }

  @Emit('change')
  private closeAction(): CloseEvent {
    return { change: false };
  }

  @Emit('change')
  private addLink(): ChangeEvent {
    this.editType = 'add';
    this.modelId = '';
    this.modelTitle = '';
    this.modelUrl = '';
    this.modelIndex = -1;
    this.titleText = i18n.tc('portal.linkAdd');
    this.saveButtonText = i18n.tc('common.add');
    BusEvent.$emit(this.editItemEvent, true);
    return { change: true };
  }

  private editLink(menu: LinkMenu, index: number) {
    this.editType = 'edit';
    this.modelId = menu.id;
    this.modelTitle = menu.title;
    this.modelUrl = menu.url;
    this.modelIndex = index;
    this.titleText = i18n.tc('portal.linkEdit');
    this.saveButtonText = i18n.tc('common.save');
    BusEvent.$emit(this.editItemEvent, true);
  }

  private changeTitle(value: string): void {
    this.modelTitle = value;
  }

  private changeUrl(value: string): void {
    this.modelUrl = value;
  }

  @Emit('save-item')
  private saveItem(): IEditItem {
    return {
      id: this.modelId,
      title: this.modelTitle,
      url: this.modelUrl,
      index: this.modelIndex,
      editType: this.editType,
    };
  }

  @Emit('save-link-menus')
  private saveLinkMenus(): void {}
}
